import React, { useContext, useEffect } from 'react';
import StatsCard from '../StatsCard';
import RevenueImage from 'images/rev1024.png';
import ConsignmentIcon from 'images/consignment-icon.png';
import { ConsignmentRootDataContext } from '../../Contexts/ConsignmentRootData';
import { formatCurrency } from 'utils';

interface ISummaryProps {
  currency?: string;
  ratio?: number;
}

const Summary: React.FC<ISummaryProps> = (props) => {
  const { currency, ratio } = props;
  const consignmentContext = useContext(ConsignmentRootDataContext);
  const isFetching = consignmentContext.value.isFetchingSummary;

  return (
    <div className={'info-container'}>
      <StatsCard
        title={'Revenue'}
        value={
          isFetching
            ? '-'
            : formatCurrency(
                consignmentContext.value.summaryData.revenue,
                ratio,
                currency,
              )
        }
        img={RevenueImage}
      />

      <StatsCard
        title={'Total Consigned Items'}
        value={
          isFetching
            ? '-'
            : consignmentContext.value.summaryData.totalConsignedItems.toString()
        }
        img={ConsignmentIcon}
      />
    </div>
  );
};

export default Summary;
